module.exports = __webpack_public_path__ + "img/swine-site1.1d060a9c.svg";